import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Media } from '../_model/media';
import { Noticias, NoticiasSend } from '../_model/Noticias';
import { NewsService } from '../_services/news.service';
import { faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-InsertNews',
    templateUrl: './InsertNews.component.html',
    styleUrls: ['./InsertNews.component.less'],
    standalone: false
})
export class InsertNewsComponent implements OnInit {

  faPencilAlt = faPencilAlt;
  faTrash = faTrash;

  constructor(private news: NewsService) { }

  noticias: Noticias[] = [];
  model: NoticiasSend = new NoticiasSend();
  apiUrl: string = environment.apiUrl;

  ngOnInit() {
    this.news.list().subscribe((data: any[]) => {
      data.forEach(el => {
        this.noticias.push(new Noticias(el));
      });
    });
    this.model.userId = localStorage.getItem("userId");
    
  }

  sendNoticia() {
    if(this.model.titulo == '') {
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta o título da Notícia</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.model.body == ''){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta o corpo da Notícia</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.model.media.length == 0){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Faltam imagens da Notícia</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else {
      this.news.send(this.model).subscribe(() => {
        this.noticias = [];
        this.news.list().subscribe((data: any[]) => {
          data.forEach(el => {
            this.noticias.push(new Noticias(el));
          });
        });
        if(this.model.id > 0) {
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Notícia actualizada com sucesso</h1>",
            icon: 'success',
            position: "top-end",
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }else{
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Notícia inserida com sucesso</h1>",
            icon: 'success',
            position: "top-end",
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }
        this.clearNoticia();
      });
    }
  }

  bindNews(item: Noticias) {
    this.model.id = item.id;
    this.model.titulo = item.titulo;
    this.model.subtitulo = item.subtitulo;
    this.model.body = item.body;
    this.news.getMedia(item.id).subscribe((data: any) => {
      this.model.media = [];
      data.forEach(el => {
        this.model.media.push(new Media(el));
      })
    });
  }

  clearNoticia() {
    this.model = new NoticiasSend();
    this.model.userId = localStorage.getItem("userId");
  }

  delete(item: Noticias) {
    Swal.fire({
      title: "Tem a certeza que pretende eliminar a notícia?",
      text: "Se continuar com esta ação irá eliminar "+item.titulo+" da base de dados",
      icon: 'warning',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      customClass: {
        confirmButton: "btn red base",
        cancelButton: "btn green base"
      }
    }).then((result) => {
      if(result.isConfirmed) {
        Swal.fire({
          title: "Notícia Eliminada com sucesso",
          text: "A notícia "+item.titulo+" foi eliminada da base de dados",
          icon: 'success'
        });
        this.news.delete(item.id, this.model.userId).subscribe(() => {
          this.model = new NoticiasSend();
          
          this.model.userId = localStorage.getItem("userId");
          this.noticias = [];
          this.news.list().subscribe((data: any[]) => {
            data.forEach(el => {
              this.noticias.push(new Noticias(el));
            });
          });
        });
      }
    });
  } 


}
